/**
 * The theme of «Спираль» (05.11.2026): light and dark are the same tokens of styles.css (`html[data-theme]`). In a browser the
 * page follows the system (no attribute, `prefers-color-scheme`); inside Telegram it follows Telegram's theme — before the first
 * paint from the launch parameters (`tgWebAppThemeParams`), then from Telegram.WebApp.colorScheme and its `themeChanged`.
 */
export type Theme = "light" | "dark";

/** The theme of Telegram's launch parameters: dark when the background Telegram draws (`bg_color`) is dark. */
export function themeOfTelegramParams(json: string | null): Theme | null {
  if (!json) return null;
  let background: unknown;
  try { background = (JSON.parse(json) as { bg_color?: unknown }).bg_color; } catch { return null; }
  const hex = typeof background === "string" ? /^#?([0-9a-f]{6})$/iu.exec(background.trim())?.[1] : undefined;
  if (!hex) return null;
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255) as [number, number, number];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b < 0.5 ? "dark" : "light";
}

/** Sets the theme (null — the system's) and the colour of the browser's own bar from the canvas of that theme. */
export function applyTheme(theme: Theme | null): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (theme) root.dataset.theme = theme;
  else delete root.dataset.theme;
}

/** A token of the current theme (`--canvas`…), with a fallback before the stylesheet has loaded. */
export function themeToken(name: string, fallback: string): string {
  if (typeof document === "undefined") return fallback;
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
}
